import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

interface ProductCardBundlePriceContentRecommendationProps {
	partNumber: string;
	name: string;
	manufacturer: string;
	discount?: string | null;
	price?: string | null;
}

const NullElement = () => null;

export const ProductCardBundlePriceContentRecommendation: React.FC<
	ProductCardBundlePriceContentRecommendationProps
> = ({ partNumber }) => {
	const ems = `DPV2BundleProductCardDescription_${partNumber}`;
	return (
		<ContentRecommendation
			id={ems}
			properties={{ emsName: ems }}
			withoutFrame
			emptyElement={<NullElement />}
			loadingElement={
				<>
					<Skeleton variant="rounded" width="80%" height="74px" />
					<Skeleton variant="rounded" width="80%" height="24px" />
				</>
			}
		/>
	);
};
